import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavbarAndSidebar from "pages/NavbarAndSidebar";
import CopyRightMessage from "layouts/CopyRightMessage/CopyRightMessage";
import MeasurementUnit from "pages/warehouse/MeasurementUnit/MeasurementUnit";
import CommodityAndServicesGroup from "pages/warehouse/CommodityAndServicesGroup/CommodityAndServicesGroup";
import CreateWarehouse from "pages/warehouse/CreateWarehouse/CreateWarehouse";
import FrequentlyServices from "pages/FrequentlyServices/FrequentlyServices";
import Login from "pages/Login/Login";
import Persons from "pages/warehouse/Persons/Persons";
import CreateWarehouseDocument from "pages/warehouse/WarehouseDocuments/CreateWarehouseDocument/CreateWarehouseDocument";
import CommodityAndServices from "pages/warehouse/CommodityAndServices/CommodityAndServices";
import EditeWarehouseDocument from "pages/warehouse/WarehouseDocuments/editeWarehouseDocument/EditeWarehouseDocument";
import WarehouseDocumentDetails from "pages/warehouse/ShowWarehouseDocumentsDetails/WarehouseDocumentsDetails";
import WarehouseDocuments from "pages/warehouse/WarehouseDocuments/WarehouseDocuments";
import CreatePerson from "pages/warehouse/Persons/CreatePerson";
import GroupPeople from "pages/warehouse/Persons/GroupPeople";
import CreateCommodityAndServices from "pages/warehouse/CommodityAndServices/CreateCommodityAndServices/CreateCommodityAndServices";
import ShowCommodityAndServicesDetails from "pages/warehouse/ShowCommodityAndServicesDetails/ShowCommodityAndServicesDetails";
import EditCommodityAndServices from "pages/warehouse/CommodityAndServices/EditCommodityAndServices/EditCommodityAndServices";
import EditPerson from "pages/warehouse/Persons/EditPerson";
import ShowPersonDetails from "pages/warehouse/Persons/ShowPersonDetails";
import AddPrefaktorDocument from "pages/prefaktor/addPrefaktorDocument/AddPrefaktorDocument";
import ShowPrefaktorDocuments from "pages/prefaktor/showPrefaktorDocuments/ShowPrefaktorDocuments";
import CreateNewConvert from "pages/warehouse/convert/CreateNewConvert/CreateNewConvert";
// import ConvertDocumnets from "pages/warehouse/convert/convertDocuments/ConvertDocumnets";
import SettingOfPrefaktorDocument from "pages/prefaktor/settingOfPrefaktorDocument/SettingOfPrefaktorDocument";
import ShowOnePrefaktorFromServer from "pages/prefaktor/showOnePrefaktorFromServer/ShowOnePrefaktorFromServer";
import InventoryOfWarehouse from "pages/warehouse/InventoryOfWarehouse/InventoryOfWarehouse";
import WarehouseReportInSummaryMode from "pages/warehouse/WarehouseReportInSummaryMode/WarehouseReportInSummaryMode";


const ProjectRoutes = () => {
  return (
    <Router>
      <NavbarAndSidebar />
      <Routes>
        <Route index element={<FrequentlyServices />} />
        <Route
          path="/warehouse/measurement-unit"
          element={<MeasurementUnit />}
        />
        <Route
          path="/warehouse/commodity-and-services-group"
          element={<CommodityAndServicesGroup />}
        />
        <Route
          path="/warehouse/create-warehouse"
          element={<CreateWarehouse />}
        />
        <Route
          path="/warehouse/commodity-and-services"
          element={<CommodityAndServices />}
        />
        <Route
          path="/warehouse/edit-commodity-and-services/:id"
          element={<EditCommodityAndServices />}
        />
        <Route
          path="/warehouse/commodity-and-services-details/:id"
          element={<ShowCommodityAndServicesDetails />}
        />
        <Route
          path="/warehouse/create-commodity-and-services"
          element={<CreateCommodityAndServices />}
        />
        <Route
          path="/warehouse/create-warehouse-document/:type"
          element={<CreateWarehouseDocument />}
        />
        <Route
          path="/warehouse/edit-warehouse-document/:type"
          element={<EditeWarehouseDocument />}
        />
        <Route
          path="/warehouse/warehouse-documents/:type"
          element={<WarehouseDocuments />}
        />
        <Route
          path="/warehouse/warehouse-document-details/:type"
          element={<WarehouseDocumentDetails />}
        />
        <Route path="/warehouse/persons" element={<Persons />} />
        <Route path="/warehouse/persons/create" element={<CreatePerson />} />
        <Route path="/warehouse/persons/edit/:id" element={<EditPerson />} />
        <Route
          path="/warehouse/persons/details/:id"
          element={<ShowPersonDetails />}
        />
        <Route path="/warehouse/persons-group" element={<GroupPeople />} />
        <Route path="/prefaktor/create-prefaktor-document" element={<AddPrefaktorDocument />} />
        <Route path="/prefaktor/show-prefaktor-documents" element={<ShowPrefaktorDocuments />} />
        <Route path="/prefaktor/show-prefaktor-document/:id" element={<ShowOnePrefaktorFromServer />} />
        <Route path="/prefaktor/prefaktor-documents-setting" element={<SettingOfPrefaktorDocument />} />

        <Route path="/warehouse/warehouse-convert" element={<CreateNewConvert />} />
        {/* <Route path="/warehouse/warehouse-convert-docs" element={<ConvertDocumnets />} /> */}
        <Route path="/warehouse/inventory-of-warehouse" element={<InventoryOfWarehouse />} />
        <Route path="/warehouse/summary-of-import-and-export-report" element={<WarehouseReportInSummaryMode />} />


        <Route path="/login" element={<Login />} />
        {/* notfound page */}
        <Route path="*" element={<FrequentlyServices />} />
      </Routes>
      <CopyRightMessage />
    </Router>
  );
};

export default ProjectRoutes;
